import type { HTMLAttributes, ReactText } from 'react';
import React from 'react';
import classNames from 'classnames';
import { Link } from '$quantum/atoms/Link';
import { Icon } from '@/components/atoms/Icon';
import styles from './index.module.scss';

export interface AskInHouseExpertsProps extends HTMLAttributes<HTMLDivElement> {
  readonly linkText: string;
  readonly children: ReactText;
  readonly anchorId?: string;
}

export function AskInHouseExperts({
  className,
  linkText,
  children,
  anchorId,
  ...props
}: AskInHouseExpertsProps): JSX.Element {
  /** @TODO replace anchor link with function call to chat */
  return (
    <div className={classNames(AskInHouseExperts.displayName, styles.component, className)} {...props}>
      <Icon className={styles.icon} id="icon_repair" width={64} />
      <div>
        <p>{children}</p>
        <Link className={styles.link} href={`#${anchorId}`} type="small">
          {linkText}
        </Link>
      </div>
    </div>
  );
}
AskInHouseExperts.displayName = 'AskInHouseExperts';
